<template>
  <div class>
    <v-toolbar dark :color="this.$gf.headerColor()">
      <v-toolbar-title>
        <v-icon class="icon">fa-pencil-alt</v-icon>Edit user
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab small @click="closePanel" :color="this.$gf.headerColor()">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-layout>
        <v-flex xs12>
          <v-card flat>
            <v-form>
              <v-text-field
                :error-messages="messages.first_name"
                v-model="user.first_name"
                label="First Name"
                type="text"
                filled
              ></v-text-field>
              <v-text-field
                :error-messages="messages.last_name"
                v-model="user.last_name"
                label="Last Name"
                type="text"
                filled
              ></v-text-field>
              <v-text-field
                :error-messages="messages.email"
                v-model="user.email"
                label="Email"
                type="text"
                filled
              ></v-text-field>
              <v-text-field
                :error-messages="messages.password"
                v-model="user.password"
                label="Password"
                type="password"
                filled
              >
                <template slot="append-outer">
                  <v-tooltip right>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on">fa fa-question</v-icon>
                    </template>
                    <span
                      >The Password must be at least 8 characters, contain 1
                      uppercase, 1 lowercase & 1 special Charecter.</span
                    >
                  </v-tooltip>
                </template>
              </v-text-field>
              <v-text-field
                :error-messages="messages.confirm_password"
                v-model="user.confirm_password"
                label="Confirm Password"
                type="password"
                filled
              >
                <template slot="append-outer">
                  <v-tooltip left>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on">fa fa-question</v-icon>
                    </template>
                    <span>The Confirm Password must be same as password.</span>
                  </v-tooltip>
                </template>
              </v-text-field>
              <v-select
                :items="noOfEmployeesOptions"
                v-model="user.banding"
                item-value="id"
                item-text="name"
                label="Number of Employees"
                attach
              ></v-select>
            </v-form>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-footer absolute height="68">
      <v-flex px-4 py-4 text-right>
        <v-btn color="primary" class="mr-1" @click="closePanel">Cancel</v-btn>
        <v-btn v-if="loading" loading></v-btn>
        <v-btn v-else color="primary" @click="updateUser">Save</v-btn>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from '@/event-bus.js';
import userAPI from '@/api/user.js';
import companyAPI from '@/api/company.js';

export default {
  name: 'Edituser',
  props: {
    id: {
      type: String,
      default: null,
    },
    params: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      messages: {},
      roles: [
        {
          name: 'User',
          id: 3,
        },
        {
          name: 'Administrator',
          id: 2,
        },
      ],
      user: {},
      groups: [],
      valid: true,
      successMessage: 'User Successfully Updated.',
      errorMessage:
        'Oops, something went wrong! Please check information is correct.',
      changeRole:
        'Are you sure you want to change users role. Updating to administrator will remove your administrator access.',
      noOfEmployeesOptions: [
        {
          id: 1,
          name: '1 to 20',
        },
        {
          id: 2,
          name: '21 to 50',
        },
        {
          id: 3,
          name: '51 to 100',
        },
        {
          id: 4,
          name: '101 to 250',
        },
      ],
      loading: false,
    };
  },
  mounted() {
    this.getUser(this.id);
  },
  methods: {
    closePanel() {
      this.$emit('closePanel', {});
    },
    changeConfirmation() {
      this.$snotify.confirm(this.changeRole, {
        backdrop: 0.3,
        buttons: [
          {
            text: 'OK',
            className: 'toast-continue-button',
            action: (toast) => this.contine(toast),
          },
        ],
      });
    },
    contine(toast) {
      this.$snotify.remove(toast.id);
    },
    getUser(id) {
      userAPI.getUser(id, '?include=groups').then((response) => {
        this.user = response.data.data;
        var a = [];
        this.user.groups.data.forEach(function (x) {
          a.push(x.id);
        });
        this.user.groups = a;
      });
    },
    updateUser() {
      this.loading = true;
      userAPI
        .updateUser(this.id, this.user)
        .then(() => {
          this.$store.dispatch('profile');
          this.loading = false;
          this.closePanel();
          EventBus.$emit('USERS_UPDATED', this.params);
          this.$snotify.success(this.successMessage);
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch((err) => {
          this.valid = false;
          this.loading = false;
          this.messages = this.$gf.errorResponse(err);
          this.$snotify.error(this.errorMessage);
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
  },
};
</script>
